<template>
  <div v-if="isBlockedCountry" class="tw:flex tw:flex-col tw:flex-1">
    <RateConnectBlockedCountryHero
      :listOfEligibleAccommodations="listOfEligibleAccommodations"
      :isLoading="isLoading"
    />
    <RateConnectNotEligibleFaq :isBlockedCountry="isBlockedCountry" />
  </div>
  <div v-else class="tw:flex tw:flex-col tw:flex-1">
    <RateConnectNoPartnerHero />
    <RateConnectSuccessStories />
    <RateConnectVideo />
    <RateConnectBenefits />
    <RateConnectGuide />
    <HowToStart />
  </div>
</template>
<script setup>
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'

import RateConnectBlockedCountryHero from '@/components/rateConnect/notEligible/RateConnectBlockedCountryHero.vue'
import RateConnectNotEligibleFaq from '@/components/rateConnect/notEligible/RateConnectNotEligibleFaq.vue'
import RateConnectNoPartnerHero from '@/components/rateConnect/notEligible/RateConnectNoPartnerHero.vue'
import RateConnectBenefits from '@/components/rateConnect/onboarding/RateConnectBenefits.vue'
import RateConnectSuccessStories from '@/components/rateConnect/onboarding/RateConnectSuccessStories.vue'
import RateConnectVideo from '@/components/rateConnect/onboarding/RateConnectVideo.vue'
import RateConnectGuide from '@/components/rateConnect/onboarding/RateConnectGuide.vue'
import HowToStart from '@/components/rateConnect/onboarding/HowToStart.vue'

import { RC_BLOCKED_COUNTRIES } from '@/constants/rcBlockedCountries'
import { useAccommodationsByOrgId } from '@/layouts/queries'
import { useCheckMultipleAccommodations } from '../queries/onboardingIndex'

const store = useStore()
const selectedOrganisationId = computed(() => store.state.session.selectedOrganisation?.id)
const { currentAccommodation, accommodationsData } = useAccommodationsByOrgId(selectedOrganisationId)
const isBlockedCountry = computed(() => RC_BLOCKED_COUNTRIES.includes(currentAccommodation.value?.countryId))

// Filter out not eligible countries accommodations
const accommodationsArrayEligibleCountry = computed(() =>
  accommodationsData.value.filter(item => !RC_BLOCKED_COUNTRIES.includes(item.countryId))
)

// Generate array of accommodations for API calls
const accommodationsIdsArray = computed(() =>
  accommodationsArrayEligibleCountry.value.map(item => item.accommodationId)
)

const { accommodationsEligibility, isLoading } = useCheckMultipleAccommodations(
  accommodationsIdsArray,
  isBlockedCountry
)

const listOfEligibleAccommodations = ref([])

watch(
  () => ({ loading: isLoading.value, data: accommodationsEligibility.value }),
  ({ loading, data }) => {
    if (!loading) {
      const eligibleIds = data.filter(accommodation => accommodation.isEligible).map(item => item.id)

      listOfEligibleAccommodations.value = accommodationsData.value.filter(item =>
        eligibleIds.includes(item.accommodationId)
      )
    }
  },
  { immediate: true }
)
</script>
